import { render, staticRenderFns } from "./MajdaFooter.vue?vue&type=template&id=bed962d0&"
import script from "./MajdaFooter.vue?vue&type=script&lang=ts&"
export * from "./MajdaFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports